.emptyList {
  margin: var(--space-m) 0 0;
  text-align: center;

  .addButton {
    display: inline-block;
  }
}
